var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiledropdownOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.031,
    height: 17.917,
    viewBox: "0 0 15.031 17.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54371",
    "data-name": "Path 54371",
    d: "M91.227,8.39a4.059,4.059,0,0,0,2.966-1.229,4.059,4.059,0,0,0,1.229-2.966,4.06,4.06,0,0,0-1.229-2.966,4.194,4.194,0,0,0-5.932,0,4.059,4.059,0,0,0-1.229,2.966,4.059,4.059,0,0,0,1.229,2.966A4.06,4.06,0,0,0,91.227,8.39ZM88.983,1.951a3.173,3.173,0,0,1,4.489,0,3.033,3.033,0,0,1,.93,2.244,3.033,3.033,0,0,1-.93,2.244,3.173,3.173,0,0,1-4.489,0,3.032,3.032,0,0,1-.93-2.244,3.032,3.032,0,0,1,.93-2.244Zm0,0",
    transform: "translate(-84.071 0)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54372",
    "data-name": "Path 54372",
    d: "M14.5,252.3a10.362,10.362,0,0,0-.141-1.1,8.671,8.671,0,0,0-.271-1.107,5.467,5.467,0,0,0-.455-1.032,3.89,3.89,0,0,0-.686-.894,3.025,3.025,0,0,0-.985-.619,3.405,3.405,0,0,0-1.258-.228,1.277,1.277,0,0,0-.682.289c-.2.133-.443.287-.71.458a4.071,4.071,0,0,1-.919.4,3.569,3.569,0,0,1-2.248,0,4.058,4.058,0,0,1-.918-.4c-.264-.169-.5-.323-.711-.458a1.275,1.275,0,0,0-.682-.289,3.4,3.4,0,0,0-1.258.228,3.022,3.022,0,0,0-.985.619,3.891,3.891,0,0,0-.686.894,5.477,5.477,0,0,0-.455,1.032A8.692,8.692,0,0,0,.176,251.2a10.29,10.29,0,0,0-.141,1.1c-.023.333-.035.679-.035,1.029a2.892,2.892,0,0,0,.859,2.188,3.092,3.092,0,0,0,2.213.807h8.386a3.092,3.092,0,0,0,2.213-.807,2.891,2.891,0,0,0,.859-2.188c0-.351-.012-.7-.035-1.029Zm-1.528,2.477a2.082,2.082,0,0,1-1.51.526H3.072a2.082,2.082,0,0,1-1.51-.526,1.888,1.888,0,0,1-.542-1.449c0-.326.011-.649.032-.958a9.283,9.283,0,0,1,.128-.991,7.664,7.664,0,0,1,.238-.975,4.458,4.458,0,0,1,.37-.839,2.884,2.884,0,0,1,.5-.661,2.006,2.006,0,0,1,.656-.408,2.349,2.349,0,0,1,.8-.155c.036.019.1.055.2.123.21.137.452.293.719.464a5.058,5.058,0,0,0,1.154.515,4.589,4.589,0,0,0,2.876,0,5.063,5.063,0,0,0,1.154-.516c.274-.175.509-.326.718-.463.1-.067.167-.1.2-.123a2.35,2.35,0,0,1,.8.155,2.009,2.009,0,0,1,.655.408,2.876,2.876,0,0,1,.5.661,4.443,4.443,0,0,1,.37.839,7.648,7.648,0,0,1,.238.975,9.36,9.36,0,0,1,.128.991h0c.022.308.033.63.033.958a1.888,1.888,0,0,1-.542,1.449Zm0,0",
    transform: "translate(0 -238.903)",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownOverview);
export default __webpack_public_path__ + "static/media/profiledropdown-overview.ea7bed2ccb5014828766240662c99357.svg";
export { ForwardRef as ReactComponent };